import request from '@/utils/request'

let IndexApi = {

  /*基础配置*/
  base(data) {
    return request._get('/api/open/base', data);
  },

  /*商城首页*/
  getCount(data) {
    return request._post('/shop/Index/index', data);
  },
   /*商城首页*/
  getCounts(data) {
    return request._post('/shop/Index/indexs', data);
  },
  getTodaySignCount(data) {
    return request._post('/shop/Index/getTodaySignCount', data);
  },

}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js